import Vue from 'vue'
import Vuex from 'vuex'
import {createVuexPersistedState} from "vue-persistedstate";
import * as actions from "./actions";
import * as mutations from "./mutations";
import * as getters from "./getters";

Vue.use(Vuex)

const state = {
    // localLang: {
    //     code: 'en-ww',
    // },
    newLogin: false,
    loadingType:false
}
export default new Vuex.Store({
    plugins: [
        createVuexPersistedState({
            key: "vuex",
            storage: window.localStorage,
            ...state
        })
    ],
    state,
    getters,
    actions,
    mutations
});
